module.exports = __webpack_public_path__ + "img/CM-SL-24-Honda-Lifestyle.7b9ba6e5.jpg";